import React from 'react'
import LayoutCol from './LayoutCol'
import LayoutRow from './LayoutRow'
import PropTypes from 'prop-types'
import { css, StyleSheet } from 'aphrodite'
import { SPACE } from '../../lib/spaces'
import { MEDIA_MIN_SM } from '../../lib/breakpoints'

const LayoutSidePanel = ({ children, menu, dynamicStyle, xs }) => {
  return (
    <div className={css(dynamicStyle)}>
      <LayoutRow dynamicStyle={styles.row} alignStart>
        {xs ? (
          <></>
        ) : (
          <LayoutCol dynamicStyle={styles.col} smallest>
            <div className={css(styles.menu)}>{menu}</div>
          </LayoutCol>
        )}
        <LayoutCol dynamicStyle={styles.width100}>{children}</LayoutCol>
      </LayoutRow>
    </div>
  )
}

const styles = StyleSheet.create({
  menu: {
    minWidth: 260,
    minHeight: '2vh',
    boxShadow: 'none',
    '@media (max-width: 1024px)': {
      minWidth: 200,
      padding: '0',
    },
    [MEDIA_MIN_SM]: {
      minWidth: 220,
      minHeight: '80vh',
      padding: SPACE,
      boxShadow: '10px 0 30px -20px #32324733',
    },
  },
  row: {
    '@media (max-width: 1024px)': {
      flexWrap: 'nowrap',
    },
    '@media (max-width: 480px)': {
      flexDirection: 'column',
    },
  },
  width100: {
    width: '100%',
  },
  col: {
    '@media (max-width: 1024px)': {
      maxWidth: '30%',
    },
  },
})

LayoutSidePanel.propTypes = {
  children: PropTypes.node.isRequired,
  menu: PropTypes.node.isRequired,
  dynamicStyle: PropTypes.object,
  xs: PropTypes.node,
}

export default LayoutSidePanel
